import { useQueryIntegrationsQuickbooks } from "../../../query/integrations/queries";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { isQuickbooksServiceActive } from "../../../query/integrations/selectors";
import React, { useState } from "react";
import { WSQueries } from "../../../query/WSQuery";
import { useQueriesOn } from "../../../shared/hooks/useQueriesOn";

export const QuickbooksWrapper: React.FC = props => {
  const qIntegrationsQuickbooks = useQueryIntegrationsQuickbooks();
  const qFeatureFlags = useFeatureFlags();
  const [render, setRender] = useState(false);

  useQueriesOn(
    "successAll",
    () => {
      setTimeout(() => setRender(true), 100);
    },
    qIntegrationsQuickbooks,
    qFeatureFlags
  );

  return (
    <WSQueries
      queries={{
        qIntegrationsQuickbooks,
        qFeatureFlags
      }}
      renderErrors={() => null}
      renderLoader={() => null}
    >
      {({ qIntegrationsQuickbooks, qFeatureFlags }) => {
        const isQuickbooksActive =
          qFeatureFlags.data.qboOnboarding &&
          (qFeatureFlags.data?.forceShowQBO ||
            isQuickbooksServiceActive(qIntegrationsQuickbooks.data));

        if (render && isQuickbooksActive) {
          return <>{props.children}</>;
        }

        return null;
      }}
    </WSQueries>
  );
};
